import { useState, useEffect } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import CharterHero from './components/CharterHero';
import WhyCharterSYG from './components/WhyCharterSYG';
import CharterInquirySection from './components/Destinations';
import CharterCTA from './components/CharterCTA';

export default function YachtCharter() {
  const [isNavVisible, setIsNavVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsNavVisible(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation isVisible={isNavVisible} setIsVisible={setIsNavVisible} />
      <CharterHero />
      <WhyCharterSYG />
      <CharterInquirySection />
      <CharterCTA />
      <Footer />
    </div>
  );
}
